import { getAuthorizationCredentials } from './GetAuthorizationCredentials';

export const CredentialsService = {
  getAuthorizationCredentials,
};
